import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import { SketchPicker } from "react-color";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from "react-select";
//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetProductOptionDetailState, getProductOptionDetail as onGetProductOptionDetails, addNewProductOptionDetail as onAddNewProductOptionDetail, updateProductOptionDetail as onUpdateProductOptionDetail, deleteProductOptionDetail as onDeleteProductOptionDetail, getProductOptionDetailLoading } from "../../../store/productOptionDetail/action";
import { getProductOption as onGetProductOptions, addNewProductOption as onAddNewProductOption, updateProductOption as onUpdateProductOption, deleteProductOption as onDeleteProductOption, getProductOptionLoading, resetProductOptionState } from "../../../store/productOption/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";

const ProductOption = () => {
  const [pIndexSecond, setPIndexSecond] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [color, setColor] = useState("#fff");
  const dispatch = useDispatch();

  const { productOptions, isProductOptionCreated, isProductOptionSuccess, loading, error, productOptionDetails, productOptionDetailLoading, isProductOptionDetailCreated, isProductOptionDetailSuccess, companies, companyLoading, clientLoading, clients } = useSelector((state) => ({
    productOptions: state.ProductOption.productOptions,
    isProductOptionCreated: state.ProductOption.isProductOptionCreated,
    isProductOptionSuccess: state.ProductOption.isProductOptionSuccess,
    loading: state.ProductOption.loading,
    error: state.ProductOption.error,
    productOptionDetails: state.ProductOptionDetail.productOptionDetails,
    productOptionDetailLoading: state.ProductOptionDetail.loading,
    isProductOptionDetailCreated: state.ProductOptionDetail.isProductOptionDetailCreated,
    isProductOptionDetailSuccess: state.ProductOptionDetail.isProductOptionDetailSuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [productOptionList, setProductOptionList] = useState([]);
  const [productOption, setProductOption] = useState([]);
  const [optionDetailAddedId, setProductOptionDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [statusActive, setStatusActive] = useState([]);
  const [productOptionDetail, setProductOptionDetail] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [detailList, setDetailList] = useState([])
  const [searchValueSecond, setSearchValueSecond] = useState([]);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);


  const onClickDelete = (productOption) => {
    setProductOption(productOption);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (productOptionDetail) => {
    setProductOptionDetail(productOptionDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteProductOption = () => {
    if (productOption) {
      dispatch(onDeleteProductOption(productOption));
      setDeleteModal(false);
    }
  };

  const handleDeleteProductOptionDetail = () => {
    if (productOptionDetail) {
      setProductOptionDetailAddedId(productOptionDetail.optionId);
      dispatch(onDeleteProductOptionDetail(productOptionDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setProductOption(employee);
    setApproveModal(true);
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredProductOptions = productOptions;
      if (type !== "all") {
        filteredProductOptions = productOptions.filter((productOption) => productOption.popt_status.name === type);
      }
      setProductOptionList(filteredProductOptions);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });

        dispatch(onGetProductOptions());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
      }
    }
  }, [dispatch, isSearch]);

  useEffect(() => {
    if (!isEmpty(productOptions)) {
      setIsEdit(false);
      setProductOptionList(productOptions);
      let current = 0;
      if (optionDetailAddedId !== 0) {
        productOptions.forEach((obj, i) => {
          if (obj.id === optionDetailAddedId) current = i;
        });
      }
      setInfo(productOptions[current]);
    }
  }, [productOptions, optionDetailAddedId]);

  useEffect(() => {
    if (isProductOptionDetailCreated) {
      dispatch(resetProductOptionDetailState());
      dispatch(resetProductOptionState());
      dispatch(onGetProductOptions());
    }
  }, [dispatch, isProductOptionDetailCreated]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setProductOption(null);
      setCompanyList([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleProductOptionClick = useCallback((arg) => {
    const data = arg;
    setProductOption({
      id: data.id,
      name: data.name,
      isColor: data.isColor,
      client: data.popt_client === null ? "" : { label: data.popt_client ? data.popt_client.name : "", value: data.popt_client ? data.popt_client.id : "" },
      company: data.popt_company === null ? "" : { label: data.popt_company ? data.popt_company.name : "", value: data.popt_company ? data.popt_company.id : "" },
    });

    setIsEdit(true);
    toggle();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setProductOptionDetail(null);
      setProductOption(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleProductOptionDetailClick = useCallback((arg, isEdit) => {
    const data = arg;
    setProductOptionDetail({
      id: data.id,
      name: data.name,
      sort_order: data.sort_order,
      optionId: data.optionId,
      description: data.description,
    });
    setColor(data.color_code);
    setIsEditDetail(isEdit);
    toggleDetail();
  }, [toggleDetail]);

  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light" className="btn-sm" onClick={() => {
                  setInfo(data);
                }}><i className="ri-eye-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  handleProductOptionClick(data);
                }}><i className="ri-edit-2-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  onClickDelete(data);
                }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
            {cellProps.row.original.statusId === 1 && (
              <button
                className="btn-label btn btn-sm btn-soft-success fs-12 ms-2"
                onClick={() => {
                  onClickApprove(data);
                }}>
                <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
              </button>
            )}
          </div>
        );
      },
    },
    {
      Header: "Product Option",
      accessor: "name",
      filterable: true,
    },
    {
      Header: "Status",
      accessor: "popt_status.name",
      filterable: true,
      Cell: (cell) => {
        switch (cell.value) {
          case "DRAFT":
            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          case "ACTIVE":
            return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
          case "INACTIVE":
            return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
          default:
            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
        }
      },
    }], [handleProductOptionClick]);

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: productOptionList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light" className="btn-sm" onClick={() => {
                  handleProductOptionDetailClick(data, true);
                }}><i className="ri-edit-2-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  onClickDeleteDetail(data);
                }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
          </div>
        );
      },
    },
    {
      Header: "Nama",
      accessor: "name",
      filterable: true,
    },
    {
      Header: "Sort",
      accessor: "sort",
      filterable: true,
    },
    {
      Header: "Keterangan",
      accessor: "description",
      filterable: true,
    }], [info]);


  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pIndexSecond,
        pageSize: 8,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };


  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  const handleApproveProductOption = () => {
    if (productOption) {
      productOption.setApprove = true;
      dispatch(onUpdateProductOption(productOption));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (productOption && productOption.name) ?? "",
      isColor: (productOption && productOption.isColor) || false,
      client: (productOption && productOption.client) || clientSelected,
      company: (productOption && productOption.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Product Name"),
    }),
    onSubmit: (values) => {
      dispatch(getProductOptionLoading());
      if (isEdit) {
        const updateProductOption = {
          id: productOption ? productOption.id : 0,
          name: values.name,
          isColor: values.isColor,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdateProductOption(updateProductOption));
        validation.resetForm();
      } else {
        const newProductOption = {
          name: values.name,
          isColor: values.isColor,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewProductOption(newProductOption));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (productOptionDetail && productOptionDetail.name) ?? "",
      sort_order: (productOptionDetail && productOptionDetail.sort_order) || 0,
      colorCode: (productOptionDetail && productOptionDetail.colorCode) ?? "",
      description: (productOptionDetail && productOptionDetail.description) ?? "",
      optionId: (productOptionDetail && productOptionDetail.optionId) || (info && info.id),
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Option Detail Name"),
    }),
    onSubmit: (values) => {
      setProductOptionDetailAddedId(values.optionId);
      dispatch(getProductOptionLoading());
      if (isEditDetail) {
        const updateProductOptionDetail = {
          id: productOptionDetail ? productOptionDetail.id : 0,
          name: values.name,
          sort_order: values.sort_order,
          color: color,
          description: values.description,
          optionId: info.id,
        };
        dispatch(onUpdateProductOptionDetail(updateProductOptionDetail));
        validationDetail.resetForm();
      } else {
        const newProductOptionDetail = {
          name: values.name,
          sort_order: values.sort_order,
          color: color,
          description: values.description,
          optionId: info.id,
        };
        dispatch(onAddNewProductOptionDetail(newProductOptionDetail));
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteProductOptionDetail(element.target.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };

    dispatch(onGetProductOptions(param));
  }

  const handleColorChangeComplete = (color) => {
    setColor(color.hex);
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (info && info.popt_detail) {
      setDetailList(info.popt_detail)
    }
  }, [info])

  useEffect(() => {
    setPIndexSecond(pageIndexSecond)
  }, [pageIndexSecond])

  document.title = "Product Options | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={productOption ? productOption.name : ""} show={approveModal} onApproveClick={handleApproveProductOption} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteProductOption} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteProductOptionDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Product Options" pageTitle="Human Resources" />
        <Row>
          <Col sm={5}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Product Option &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createProductOption") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                      id="create-btn"
                      onClick={() => {
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} /><i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}><i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}</Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Product Option" : "Add Product Option"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp; {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp; {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Name
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Input name="isColor" id="isColor-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isColor} /> &nbsp;
                            <Label htmlFor="isColor-field" className="form-label">
                              is Color ?
                            </Label>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Product Option"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Edit Product Option" : "Add Product Option"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-8">
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Name
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.name ?? ""} invalid={validationDetail.touched.name && validationDetail.errors.name ? true : false} />
                            {validationDetail.touched.name && validationDetail.errors.name ? <FormFeedback type="invalid">{validationDetail.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Description
                            </Label>
                            <Input name="description" id="description-field" rows="6" className="form-control" placeholder="Description" type="textarea" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.description} invalid={validationDetail.touched.description && validationDetail.errors.description ? true : false} />
                            {validationDetail.touched.description && validationDetail.errors.description ? <FormFeedback type="invalid">{validationDetail.errors.description}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="sort_order-field" className="form-label">
                              Sort Order
                            </Label>
                            <Input name="sort_order" id="sort_order-field" className="form-control" placeholder="Enter short order" type="text" onChange={validationDetail.handleChange} defaultValue={0} onBlur={validationDetail.handleBlur} value={validationDetail.values.sort_order} invalid={validationDetail.touched.sort_order && validationDetail.errors.sort_order ? true : false} />
                          </div>
                          <div className="mb-3">
                            {info.isColor ? (
                              <SketchPicker
                                color={color}
                                onChangeComplete={(e) => {
                                  handleColorChangeComplete(e);
                                }} />
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEditDetail ? "Update" : "Add Product Option Detail"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
          <Col sm={7}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className="btn btn-success add-btn"
                    id="create-btn"
                    onClick={() => {
                      setProductOption(info);
                      setIsEditDetail(false);
                      toggleDetail();
                    }}><i className="ri-list-check label-icon align-middle fs-13 me-1"></i>Add Detail
                  </button>
                </div>
              </div>
              <div className="card-body">
                <Row>
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2">
                            <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                              {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                <option key={pageSizeSecond} value={pageSizeSecond}>
                                  {pageSizeSecond}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValueSecond(e.target.value);
                                onChangeSecond(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`Search...`}
                              value={searchValueSecond ?? ""} />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Page
                    <strong>
                      {pageIndexSecond + 1} of {pageOptionsSecond.length}
                    </strong>
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} value={pIndexSecond + 1} onChange={onChangeInInputSecond} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductOption;
